export default __webpack_public_path__ + "static/media/boxing.971bf464.png";